import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Menu } from '../models';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private readonly menuBehavior = new BehaviorSubject<Menu[]>([]);
  readonly menu$ = this.menuBehavior.asObservable();

  constructor(private http: HttpClient) { }

  load(): void {
    this.http.get<Menu[]>(`${environment.apiUrl}/menu`)
      .subscribe(response => {
        this.menuBehavior.next(response);
      });
  }

}